module.exports = __webpack_public_path__ + "img/banner2_camera.24c5524b.png";